







































import { defineComponent, useRouter } from '@nuxtjs/composition-api'

// Composables
import useFacets from '@/composables/search/useFacets'
import useSearchUrl from '@/composables/search/useSearchUrl'
import useSearchAnalytics from '@/composables/analytics/useSearchAnalytics'

// Store
import { useSearchStore } from '@/store/search'

// Common
import { multiSelectFacets } from '@/common/static/facets'
import { decodeHTMLEntities } from '@/common/utils/characters'
import { NESTED_FACET_NAMES } from '@/common/static/search'

// Types
import { FacetInterface } from '@/types/search/searchTypes'

export default defineComponent({
  props: {
    items: {
      type: Array as () => Array<FacetInterface>,
      required: true,
      default: () => [],
    },
    options: {
      type: Object,
      required: true,
    },
  },

  setup(props, { emit }) {
    const { trackFilteredSearch } = useSearchAnalytics()
    const { adjustCheckedFacets, facetSelected } = useFacets()
    const searchStore = useSearchStore()
    const { getSearchUrl } = useSearchUrl()
    const router = useRouter()
    const isMultiSelect = multiSelectFacets.includes(props.options.key)

    // On facet click
    const facetClick = (key: string, value: string) => {
      // if facet is other, select the facet with a value of true
      adjustCheckedFacets(key, value)

      // Clear filter in parent component
      emit('onFacetClick')

      // send GTM event
      trackFilteredSearch(key, value)

      // store the facet values for a isMultiSelect
      if (isMultiSelect) {
        searchStore.setFacetState(props.options.key)
      } else {
        searchStore.clearMultiselectFacetState()
      }

      // Perform search
      router.push(getSearchUrl({ noscroll: true }))
    }

    return {
      facetSelected,
      facetClick,
      decodeHTMLEntities,
      NESTED_FACET_NAMES,
      isMultiSelect,
    }
  },
})
